import * as React from 'react';
import debounce from 'lodash/debounce';

class DebouncedInputField extends React.Component {
  static defaultProps = {
    value: '',
    onChange: () => {},
    type: 'text'
  };

  state = {
    value: this.props.value,
    lastDebouncedValue: this.props.value || '',
    isDebouncing: false
  };

  UNSAFE_componentWillMount() {
    // Have to create the debounced function here instead of specifying it as
    // a separate field in order for the debounced function to be generated
    // separately for each component instance.
    this._scheduleChange = debounce(() => this._commitChange(), 1000);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.isDebouncing) {
      this.setState({
        value: nextProps.value,
        lastDebouncedValue: nextProps.value
      });
    }
  }

  componentWillUnmount() {
    this._scheduleChange.cancel();
  }

  render() {
    return (
      <input
        {...this.props}
        type={this.props.type}
        value={this.state.value}
        onChange={this._handleChange}
        onBlur={this._handleBlur}
      />
    );
  }

  _handleChange = evt => {
    this.setState({
      value: evt.target.value
    });

    this.setState({ isDebouncing: true });
    this._scheduleChange();
  };

  _handleBlur = () => {
    this._commitChange();
  };

  _commitChange = () => {
    if (this.state.lastDebouncedValue !== this.state.value) {
      this.setState({ lastDebouncedValue: this.state.value });
      this.props.onChange(this.state.value);
    }
    this.setState({ isDebouncing: false });
  };
}

export default DebouncedInputField;
